/* Site sections runtime (home, research, generic sections). Small, deferred, no dependencies.
   - [data-tabs]: filter tabs for the FAQ (role=tablist buttons with data-tab, panels with data-cat)
   - [data-lazy-video]: poster button that swaps in the <template> video on click
   - video[data-autoplay-visible]: muted loops that only load/play while on screen */
const reduced = matchMedia('(prefers-reduced-motion: reduce)');

function initTabs(root = document) {
  root.querySelectorAll('[data-tabs]:not([data-tabs-ready])').forEach((wrap) => {
    wrap.setAttribute('data-tabs-ready', '');
    const tabs = [...wrap.querySelectorAll('[data-tab]')];
    const items = [...wrap.querySelectorAll('[data-cat]')];
    const select = (tab) => {
      const cat = tab.dataset.tab;
      tabs.forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
      items.forEach((it) => { it.hidden = cat !== 'all' && it.dataset.cat !== cat; });
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        next.focus(); select(next);
      });
    });
  });
}

function initLazyVideo(root = document) {
  root.querySelectorAll('[data-lazy-video]:not([data-ready])').forEach((btn) => {
    btn.setAttribute('data-ready', '');
    btn.addEventListener('click', (e) => {
      const tpl = btn.parentElement.querySelector('template');
      if (!tpl) return;
      e.preventDefault();
      const node = tpl.content.cloneNode(true);
      const video = node.querySelector('video');
      btn.replaceWith(node);
      video?.play?.().catch(() => {});
      window.NGM?.track?.('video_play', { src: video?.currentSrc || '' });
    });
  });

  root.querySelectorAll('video[data-autoplay-visible]:not([data-ready])').forEach((v) => {
    v.setAttribute('data-ready', '');
    if (reduced.matches) return; // poster only
    // Loops layered over a still (.n-vloop) stay transparent until real frames play, so a slow or
    // unsupported clip never covers the photo with a black box.
    v.addEventListener('playing', () => v.classList.add('is-playing'), { once: true });
    const start = () => {
      const pending = v.querySelectorAll('source[data-src]');
      pending.forEach((s) => { s.src = s.dataset.src; s.removeAttribute('data-src'); });
      if (pending.length) v.load();
      v.play?.().catch(() => {});
    };
    if (!('IntersectionObserver' in window)) { start(); return; }
    new IntersectionObserver(([en]) => {
      if (en.isIntersecting) start();
      else v.pause?.();
    }, { rootMargin: '100px' }).observe(v);
  });
}

function init(root) { initTabs(root); initLazyVideo(root); }
init(document);
document.addEventListener('shopify:section:load', (e) => init(e.target));
